import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormikContext } from "formik";
import { css, cx } from "@emotion/css";
import { Paragraph } from "../../text";
import { useBlockComponentContext } from "../BlockComponentContext";
import { ADAPTABLE_TEXT_CLASSNAME } from "../block-slide";
export const BlockParagraph = ({ horizontalAlignment, translationKey, staticContent, staticText = "", }) => {
    const { Markdown, Translated } = useBlockComponentContext();
    const { values } = useFormikContext();
    return (_jsx("div", { style: { textAlign: horizontalAlignment }, children: _jsxs(Paragraph, { className: cx(ADAPTABLE_TEXT_CLASSNAME, style), fontSize: "1.25em", lineHeight: "1.75em", children: [staticText, _jsx(Translated, { translationKey: translationKey, render: ({ translation }) => (_jsx(Markdown, { values: values, source: translation, staticContent: staticContent })) })] }) }));
};
BlockParagraph.defaultProps = {
    horizontalAlignment: "left",
};
const style = css `
  margin-bottom: 0.625em;
`;
